module.exports = __webpack_public_path__ + "yubico_ico@2x.89a03a00a16121182f80e7fec2548f1e.png";